module.exports = __webpack_public_path__ + "static/media/from-the-crowd.25532901.jpg";